<template>
  <span>
    <svg
      v-if="type === 'vecura'"
      viewBox="70 55 1080 890"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <polygon
        fill="currentColor"
        points="357.1 918 358.2 613.4 1107.4 103.7 1109.1 405.2 357.1 918"
      />
      <path
        fill="currentColor"
        d="M347.4,105.7c-17.3,7.9-34,16.8-50,26.8l-15.3,10.1c-111.6,76.8-184.9,205.3-184.9,351s27.7,172.6,74.9,241.1l184.9-121.7V102.3l-9.7,3.4Z"
      />
    </svg>

    <svg
      v-else-if="type === 'linkedin'"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M6.94 8.98H3.78v10.19h3.16V8.98ZM5.36 7.59a1.84 1.84 0 1 0 0-3.68 1.84 1.84 0 0 0 0 3.68ZM20.22 13.56c0-3.06-1.63-4.48-3.8-4.48a3.27 3.27 0 0 0-2.96 1.63h-.04V8.98h-3.03v10.19h3.16v-5.04c0-1.33.25-2.61 1.9-2.61 1.62 0 1.64 1.52 1.64 2.69v4.96h3.15v-5.61Z"
      />
    </svg>

    <svg
      v-else
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="18" height="14" x="3" y="5" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type ContactChannelType = "mail" | "linkedin" | "vecura";

export default defineComponent({
  name: "ContactChannelIcon",
  props: {
    type: {
      type: String as PropType<ContactChannelType>,
      required: true,
    },
  },
});
</script>
